export default __webpack_public_path__ + "static/media/congratulations.3ad8a710.png";